import { writable } from 'svelte/store';
export const stateInitialTime = writable(0);
export const stateTime = writable(0);
export const stateTimerEnded = writable(undefined);
